import React from "react";
import Project from "./projet";

export function ProjectFinished() {
  return <Project status="Terminé" />;
}